import React, { FC } from 'react';
import { Typography, useTheme } from '@mui/material';
import { IGmbLocation } from '../../../shared/interfaces/IGmbLocation';

interface Props {
  locationId: string;
  locations?: IGmbLocation[];
}

const GoogleLocationInfo: FC<Props> = ({ locationId, locations }) => {
  const theme = useTheme();

  if (!locations) {
    return null;
  }

  const match = locations.find((location) => location.locationID === locationId);

  if (!match) {
    return null;
  }

  return (
    <Typography
      sx={{
        ml: theme.spacing(2),
        fontSize: '0.75rem',
        color: theme.palette.text.secondary,
      }}
    >
      {match.locationData.title} <br />
      {match.locationData.address.addressLines} <br />
      {match.locationData.address.postalCode} {match.locationData.address.locality}
    </Typography>
  );
};

export default GoogleLocationInfo;
